import { getLocalStorageData } from '../../utils/helper';
import { APP_API_URL_V2 } from '../../utils/xhr-instance';
import { axiosInstanceV2 } from '../axios';

export async function createPaymentsReceived(data) {
	const API_URL = `${APP_API_URL_V2}/sales/payment-receives`;
	const token = getLocalStorageData();
	return await axiosInstanceV2
		.post(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => {
			return res.data;
		})
		.catch((err) => {
			return err?.response?.data;
		});
}
export async function updatePaymentsReceived(id, data) {
	const API_URL = `${APP_API_URL_V2}/sales/payment-receives/${id}`;
	const token = getLocalStorageData();

	return await axiosInstanceV2
		.put(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		})
		.then((res) => res.data)
		.catch((err) => err?.response?.data || 'Something went wrong');
}
export async function fetchPaymentReceivedNumber() {
	const token = getLocalStorageData();
	try {
		const { data } = await axiosInstanceV2.get(`${APP_API_URL_V2}/sales/payment-receives/number`, {
			headers: {
				Authorization: `Bearer ${token?.token}`,
			},
		});
		return data.data.payment_receive;
	} catch (error) {
		throw error?.response?.data;
	}
}

export async function fetchCustomerInvoice(customerId) {
	const token = getLocalStorageData();
	try {
		const { data } = await axiosInstanceV2.get(
			`${APP_API_URL_V2}/customer/${customerId}/invoices`,
			{
				headers: {
					Authorization: `Bearer ${token?.token}`,
				},
			},
		);
		return data.data.customer;
	} catch (error) {
		throw error?.response?.data;
	}
}
export async function deletePaymentReceived(id) {
	const token = getLocalStorageData();
	try {
		const { data } = await axiosInstanceV2.delete(`${APP_API_URL_V2}/sales/payment-receives/`, {
			data: {
				ids: [id],
			},
			headers: {
				Authorization: `Bearer ${token?.token}`,
			},
		});
		return data.data;
	} catch (error) {
		throw error?.response?.data;
	}
}

export async function fetchPaymentsReceivedList(data) {
	const token = getLocalStorageData();
	try {
		const res = await axiosInstanceV2.post(`${APP_API_URL_V2}/sales/payment-receives/list`, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token?.token}`,
			},
		});
		return res.data.data;
	} catch (error) {
		throw error?.response?.data;
	}
}

export async function fetchPaymentReceivedDetails(data) {
	const token = getLocalStorageData();
	try {
		const res = await axiosInstanceV2.post(
			`${APP_API_URL_V2}/sales/payment-receives/details`,
			data,
			{
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token?.token}`,
				},
			},
		);
		return res.data.data;
	} catch (error) {
		throw error?.response?.data;
	}
}
export async function adjustRefundAmount(data) {
	const token = getLocalStorageData();
	try {
		const res = await axiosInstanceV2.post(
			`${APP_API_URL_V2}/sales/payment-receives/adjust-amount`,
			data,
			{
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token?.token}`,
				},
			},
		);
		return res.data;
	} catch (error) {
		throw error?.response?.data;
	}
}

export async function sendEmail(id, data) {
	const token = getLocalStorageData();
	try {
		const { res } = await axiosInstanceV2.post(
			`${APP_API_URL_V2}/sales/payment-receives/${id}/send/email`,
			data,
			{
				headers: {
					Authorization: `Bearer ${token?.token}`,
				},
			},
		);
		return res;
	} catch (error) {
		throw error?.response?.data;
	}
}

export async function generateSalesPaymentReceivedPdf(id, merge = false) {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstanceV2.get(
			`${APP_API_URL_V2}/sales/payment-receives//generate-pdf?ids=${id}&merge=${merge}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data?.data.signed_urls[0];
	} catch (error) {
		throw new Error(error?.response?.data?.message);
	}
}
